import { defineComponent as _defineComponent } from 'vue'
import { computed } from '@nuxtjs/composition-api';
import { useMediaAsset } from '~/composables';
import { Swiper, SwiperSlide } from 'vue-awesome-swiper';

interface CategoryApp {
  id: string;
  name: string;
  text: string;
  image: string;
}
interface Props {
  data: {
    title?: string;
    text?: string;
    items?: CategoryApp[];
  };
}


export default /*#__PURE__*/_defineComponent({
  __name: 'CategoryApplications',
  props: {
    data: { default: () => ({
    title: '',
    text: '',
    items: [],
  }) }
  },
  setup(__props: any) {

const props = __props as { data: {
    title?: string;
    text?: string;
    items?: CategoryApp[];
  } };



const { getAssetUrl } = useMediaAsset();

const swiperOptions = {
  observer: true,
  slidesPerView: 'auto',
  spaceBetween: 16,
  breakpoints: {
    1024: {
      slidesPerView: 4,
    },
  },
  scrollbar: {
    el: '.swiper-scrollbar',
    draggable: true,
    dragSize: 180,
    snapOnRelease: true,
  },
};

const apps = computed<CategoryApp[][]>(() => {
  return !props.data?.items
    ? []
    : props.data.items.reduce((items, item, i) => {
        const chunkIndex = Math.floor(i / 2);

        // eslint-disable-next-line no-param-reassign
        items[chunkIndex] = items[chunkIndex] || [];
        // @ts-ignore
        items[chunkIndex].push(item);

        return items;
      }, []);
});

const getImage = (src: string) => getAssetUrl(src) ?? undefined;

return { __sfc: true,props, getAssetUrl, swiperOptions, apps, getImage, Swiper, SwiperSlide }
}

})